export const gqlGetPartnerCurrentLocation = /* GraphQL */ `
  query GetPartnerCurrentLocation(
    $user_id: String!
    $job_id: String!
  ) {
    getPartnerCurrentLocation(
      user_id: $user_id
      job_id: $job_id
    ) {
      resource_name
      timestamp
      position {
        latitude
        longitude
        altitude
        accuracy
        heading
        speed
      }
    }
  }
`;
